<div class="main-container">
  <div class="ui grid">
    <div class="sixteen wide mobile eleven wide tablet eleven wide computer column">
      <h1>
        <i class="setting icon"></i>
        Settings
      </h1>
    </div>

    <div class="sixteen wide mobile five wide tablet right floated four wide computer column">
      <div class="ui buttons right floated" v-if="$store.getters['user/isPlatformAdmin']">
        <a class="ui secondary button import-csv" v-on:click="importCsvVisible = true">Import .csv</a>
        <a class="ui primary button new-material" v-on:click="newMaterial">New Product</a>
      </div>
      <a class="ui fluid right floated primary button new-material"
         v-on:click="newMaterial"
         v-else-if="activeTab === 'custom'">
        New Product
      </a>
    </div>

    <!-- Sidebar Menu -->
    <div class="sixteen wide mobile four wide tablet four wide computer column settings-side-menu">
      <app-setting-sidebar
              active_tab="material">
      </app-setting-sidebar>
    </div>

    <div class="sixteen wide mobile twelve wide tablet twelve wide computer column settings-main-content">
      <div class="ui top attached tabular menu">
        <a class="item" :class="{ active: activeTab === 'default' }" @click="changeTab('default')">Default</a>
        <a class="item" :class="{ active: activeTab === 'custom' }" @click="changeTab('custom')" v-if="!$store.getters['user/isPlatformAdmin']">Custom</a>
      </div>

      <!-- Tab Content -->
      <div class="ui bottom attached tab segment active">
        <form class="ui form settings">
          <!-- Search and Filters -->
          <div class="two fields">
            <div class="field settings">
              <label>Search Products</label>
              <app-text-input
                icon="search"
                placeholder="Search"
                v-model="searchText">
              </app-text-input>
            </div>
            
            <div class="field settings">
              <label>Filter by Type</label>
              <app-select :defaultLabel="'All Types'" :default-selectable="true" :value="filterType" :items="materialTypes"
                @selected="filterByType($event.id)">
              </app-select>
            </div>
          </div>

          <table class="ui basic sortable selectable celled padded table" v-if="!loading && materials.length > 0">
            <tbody>
            <template v-for="(material, index) in materials" :key="material.id || index">
              <tr class="material-row clickable">
                <td @click="viewMaterial(material, $event)" style="cursor: pointer;">
                  <img :src="getImageUrl(material)" class="ui mini image" alt="Material image">
                </td>
                <td @click="viewMaterial(material, $event)" style="cursor: pointer;">{{ displayCatalogName(material.description) }}</td>
              </tr>
            </template>
            </tbody>
          </table>

          <!-- Empty State -->
          <div v-if="!loading && materials.length === 0" class="empty-state-container">
            <div class="empty-state-content">
              <h3 class="empty-state-title">No products found</h3>
              <p class="empty-state-description">
                <span v-if="activeTab === 'default'">Default products will appear here</span>
                <span v-else-if="activeTab === 'custom'">Custom created products will appear here</span>
              </p>
            </div>
          </div>

          <!-- Loading State -->
          <app-loader v-if="loading"></app-loader>
        </form>

        <!-- Pagination -->
        <div v-if="!loading && paginator.total > 0" class="pagination-controls">
          <app-pagination
            :page="paginator.page"
            :total-pages="paginator.totalPages"
            @change="getMaterials"
          />
          <div class="ui text muted" style="margin-top: 10px;">
            Showing {{ (paginator.page - 1) * paginator.limit + 1 }} to {{ Math.min(paginator.page * paginator.limit, paginator.total) }} of {{ paginator.total }} products
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-import-csv-modal
    v-if="importCsvVisible"
    @close="importCsvVisible = false"
    @imported="getMaterials(1)">
  </app-import-csv-modal>
</div>





